<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <p v-if="!showSuccessAlert">{{ $t('kkm.setCanChangePublicKeyConfirmText') }}</p>
        <b-form-row class="justify-content-end mx-0" v-if="!showSuccessAlert">
            <b-button type="button" variant="danger" @click="closeModal" :disabled="isDisabled" class="mr-2">
                <close-icon title="" />&nbsp;{{ $t('kkm.no') }}
            </b-button>
            <b-button type="submit" variant="success" :disabled="isDisabled" @click="setCanChangePublicKey">
                <save-icon title="" />&nbsp;{{ $t('kkm.yes') }}
            </b-button>
        </b-form-row>
    </b-card>
</template>

<script>
import AppData from '@/utils/appdata'

export default {
    name: 'KkmSetCanChangePublicKey',
    mixins: [ AppData ],
    props: {
        kkmId: Number,
        closeModal: Function
    },
    data () {
        return {
            formData: {
                id: this.kkmId
            }
        }
    },
    methods: {
        setCanChangePublicKey: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.canChangePublicKey,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.setCanChangePublicKeySuccess')
                }, this.displayAlert)
        }
    }
}
</script>
